import {
  CustomerObject,
  Transfer,
  AlternativeTransfer,
} from '../../../interfaces'
import { Hospital, RecurrenceObject } from '../interfaces'
import CustomDialog from '../../../../CustomDialog'
import { CustomLoader } from '../../../../CustomLoader'
import DateInput from '../../../../DateInput'
import { DriverSelectModal } from '../../../../DriverSelectModal/ui/DriverSelectModal'
import { EditTransferServiceFooter } from '../components/EditTransferServiceFooter/EditTransferServiceFooter'
import GridContainer from '../../../../Grid/GridContainer'
import GridItem from '../../../../Grid/GridItem'
import React from 'react'
import RegularMapWithDirections from '../../../../RegularMapWithDirections/RegularMapWithDirections'
import SchedulePlanTransfer from '../../../../SchedulePlan/SchedulePlanTransfer'
import SelectInput from '../../../../SelectInput'
import TimePickerGCalendar from '../../../../TimePickerGCalendar'
import ValidationInput from '../../../../ValidationInput'
import { useEditTransferService } from '../hooks/useEditTransferServiceDialog'
import { useTranslation } from 'react-i18next'
import { convertTo12HourFormat } from '../../../../../util/dateUtils/dateFormatters'

export interface EditTransferServiceProps {
  open: boolean
  onClose: () => void
  onSave: () => void
  disabled: boolean
  itemData: Transfer | AlternativeTransfer
  customer: CustomerObject
  itemSelect: number
}

export const EditTransferService: React.FC<EditTransferServiceProps> = ({
  open,
  onClose,
  disabled,
  itemData,
  customer,
  itemSelect,
  onSave,
}) => {
  const { t } = useTranslation()

  const {
    isLoading,
    transferTypes,
    transferType,
    handleValue,
    hospitals,
    hospital,
    startDate,
    startTime,
    recurrence,
    distance_suggested,
    time_end_suggested,
    startLatitude,
    startLongitude,
    handleDirectionsCalculated,
    canAssignDriver,
    handleDriversModal,
    saveService,
    openDriverModal,
    onSaveDriver,
    driver,
    destinationLatitude,
    destinationLongitude
  } = useEditTransferService({ itemData, customer, itemSelect, onSave })

  return (
    <CustomDialog
      maxWidth={'md'}
      title={t('service.title')}
      open={open}
      onClose={onClose}
    >
      <>
        {isLoading ? (
          <CustomLoader />
        ) : (
          <GridContainer>
            <GridItem xs={6} sm={6} md={6} className="componentType">
              <GridItem xs={12} sm={12} md={12}>
                <SelectInput
                  label={t('service.traslado')}
                  elements={transferTypes ?? []}
                  disabled={true}
                  value={transferType}
                />
              </GridItem>
              <GridItem xs={12} className="margin-left">
                <h4 className="label-services">
                  {t('service.destino') as string}
                </h4>
              </GridItem>

              <GridItem xs={12} sm={12} md={12}>
                <ValidationInput
                  type="text"
                  text={`${t('common.description')}`}
                  disabled={true}
                  value={
                    hospitals?.find(
                      (h: Hospital) => h.hospitalId === hospital?.hospitalId
                    )?.businessName ?? ''
                  }
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <ValidationInput
                  type="text"
                  text={`${t('service.address')}`}
                  disabled={true}
                  value={hospital ? hospital.address : ''}
                />
              </GridItem>
              <GridContainer>
                <GridItem xs={5} sm={5} md={5}>
                  <DateInput
                    text={t('service.start_date')}
                    disabled={true}
                    minDate
                    onChangeValue={(value: string) =>
                      handleValue('startDate', value)
                    }
                    value={startDate}
                  />
                </GridItem>
                <GridItem xs={6} sm={6} md={6} className="timeInput">
                  <TimePickerGCalendar
                    text={t('service.requested.pickup.time')}
                    value={convertTo12HourFormat(startTime ?? "")}
                    name="start_time"
                    disabled={true}
                    onSelectedValue={(value: string) =>
                      handleValue('startTime', value)
                    }
                    invalid={!startTime}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <SchedulePlanTransfer
                    isTraslado={true}
                    indexArrayDays={0}
                    disabledAgenda={disabled}
                    insideModule={false}
                    current={recurrence}
                    invalidPlan={() => false}
                    onCreatedRecurrence={(value: RecurrenceObject) =>
                      handleValue('recurrence', value)
                    }
                    className="schedule-plan-component"
                    onlyDate={true}
                  />
                </GridItem>
              </GridContainer>
            </GridItem>
            <GridItem xs={6} sm={6} md={6}>
              <GridContainer>
                <GridItem xs={5} sm={5} md={5}>
                  <ValidationInput
                    text={`${t('service.distance')}`}
                    type="text"
                    disabled={true}
                    value={distance_suggested}
                  />
                </GridItem>
                <GridItem xs={5} sm={5} md={5}>
                  <ValidationInput
                    text={`${t('service.time_start_destination')}`}
                    type="text"
                    disabled={true}
                    value={time_end_suggested}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  {startLatitude && destinationLatitude && <RegularMapWithDirections
                      startPoint={{
                        latitude: startLatitude,
                        longitude: startLongitude,
                      }}
                      endPoint={{
                        latitude: destinationLatitude,
                        longitude: destinationLongitude,
                      }}
                      onDirectionsCalculated={(data: {
                        distance_suggested: string
                        time_end: string
                      }) => {
                        handleDirectionsCalculated({
                          distance: data.distance_suggested,
                          time: data.time_end,
                        })
                      }}
                    />}                      
                </GridItem>
                <GridItem xs={12} sm={12} md={12} style={{ marginTop: '16px' }}>
                  {!disabled && (
                    <EditTransferServiceFooter
                      canAssignDriver={canAssignDriver() ?? false}
                      openDrivers={(e) => handleDriversModal(e, true)}
                      saveService={saveService}
                    />
                  )}
                </GridItem>
              </GridContainer>
            </GridItem>
          </GridContainer>
        )}
        {openDriverModal && (
          <DriverSelectModal
            openDrivers={openDriverModal}
            closeModalDrivers={(e) => handleDriversModal(e, false)}
            onSaveDriver={onSaveDriver}
            driver={driver}
          />
        )}
      </>
    </CustomDialog>
  )
}
